import styled from "styled-components";

export const ButtonLink = styled.a`
  margin-left: ${(props) => props.firstStep && "auto"};

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  &.delay-1 {
    animation-delay: 0.25s;
  }

  &.delay-2 {
    animation-delay: 0.35s;
  }

  &.delay-3 {
    animation-delay: 0.45s;
  }

  &.delay-4 {
    animation-delay: 0.55s;
  }

  &.delay-5 {
    animation-delay: 0.65s;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInUp {
    animation-name: fadeInUp;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }
`;

export const ButtonContainer = styled.button`
  font-weight: bold;
  color: ${(props) => props.buttonType === "primary" && "#fff"};
  color: ${(props) => props.buttonType === "secondary" && "#f2008c"};
  color: ${(props) => props.buttonType === "secondaryWhite" && "#fff"};
  color: ${(props) => props.buttonType === "tertiary" && "#333"};
  background: ${(props) => props.buttonType === "primary" && "#f2008c"};
  background: ${(props) => props.buttonType === "secondary" && "transparent"};
  background: ${(props) => props.buttonType === "tertiary" && "#fff"};
  background: ${(props) => props.buttonType === "secondaryWhite" && "#3B045D"};
  border: ${(props) => props.buttonType === "primary" && "1px solid #f2008c"};
  border: ${(props) => props.buttonType === "secondary" && "1px solid #f2008c"};
  border: ${(props) => props.buttonType === "tertiary" && "1px solid #fff"};
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  padding: 10px 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  transition: 0.15s ease-in-out;
  z-index: ${(props) => props.textareaFocused && "2"};

  &:hover {
    cursor: pointer;
    color: ${(props) => props.buttonType === "primary" && "#fff"};
    color: ${(props) => props.buttonType === "secondary" && "#fff"};
    color: ${(props) => props.buttonType === "secondaryWhite" && "#f2008c"};
    color: ${(props) => props.buttonType === "tertiary" && "#333"};
    background: ${(props) => props.buttonType === "primary" && "#bc006d"};
    background: ${(props) => props.buttonType === "secondary" && "#bc006d"};
    background: ${(props) => props.buttonType === "tertiary" && "#fff"};
    border: 1px solid #f2008c;
  }

  &:active,
  &:visited {
    cursor: pointer;
    color: #fff;
    background: #673490;
    border: 1px solid #673490;
    outline: none;
  }

  &[data-disabled="true"],
  &[data-disabled="true"]:hover {
    border: 1px solid grey;
    background: transparent;
    color: grey;
    pointer-events: none;
    cursor: no-drop;
  }

  &:focus {
    background: ${(props) => (props.resetButtonFocus ? null : "#673490")};
    background: ${(props) =>
      props.noFocus && props.buttonType === "secondaryWhite" && "transparent"};
    border: ${(props) => (props.resetButtonFocus ? null : "1px solid #673490")};
    border: ${(props) =>
      props.noFocus &&
      props.buttonType === "secondaryWhite" &&
      "1px solid #fff"};
    background: ${(props) =>
      props.noFocus && props.buttonType === "primary" && "#f2008c"};
    border: ${(props) =>
      props.noFocus && props.buttonType === "primary" && "1px solid #f2008c"};
    outline: none;
  }
`;
